import React, { ReactNode } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ReactDOM from "react-dom";

type ModalObservacoesProps = {
  observacao?: string,
  children?: ReactNode,
  visivel: boolean,
  save: any,
  hide: any,
};

class ModalObservacoes extends React.Component<ModalObservacoesProps, {}> {

  constructor(props: ModalObservacoesProps) {
    super(props);
    this.saveObservacoes = this.saveObservacoes.bind(this);
  }

  saveObservacoes(): void {
    const obs: any = ReactDOM.findDOMNode(this.refs.observacao);
    this.props.save(obs.value);
  }

  render(): any {
    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal" id="obs-modal">
            <p className="title">Como você deseja seu produto?</p>
            <textarea placeholder="Observação" ref="observacao" defaultValue={this.props.observacao}></textarea>
            <div className="menu">
            <button onClick={ this.props.hide }>Cancelar</button>
              <button onClick={ this.saveObservacoes }>Salvar</button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalObservacoes;